// extracted by mini-css-extract-plugin
export default {"container_card":"_card_container_card__O2SS4","card":"_card_card__HcSKp","title":"_card_title__o+DIP","amount":"_card_amount__-6DDO"};